import { gql } from "@apollo/client";

export const GET_MINUTA_ITEMS_EVALUACION = gql`
    query GetConexionesEvaluacionMinuta($filter: MinutaItemEvaluacionFilterInput!) {
    conexionesEvaluacionMinuta(filter: $filter) {
        idConexion,
        fechaConexion,
        justificacion,
        color
    }
}
`;

export const adaptMinutaItemsEvaluacion = (conexion) => {
  return {
    idConexion: conexion?.idConexion,
    fechaConexion: conexion?.fechaConexion,
    justificacion: conexion?.justificacion,
    color: conexion?.color
  };
};

export const adaptMinutaItemsEvaluacionArray = (conexiones) => {
  return structuredClone(conexiones)?.
  map((conexion) => adaptMinutaItemsEvaluacion(conexion));
};